<template>
  <div class="card p-2">
    <div class="table-responsive">
      <table class="table table-hover plan-table">
        <thead>
        <tr>
          <th>Plan No</th>
          <th>Title</th>
          <th>Product</th>
          <th>Machine/Line</th>
          <th>Schedule</th>
          <th class="text-end">Planned</th>
          <th class="text-end">Produced</th>
          <th class="text-end">Remaining</th>
          <th style="min-width: 120px;">Progress</th>
          <th>Order</th>
          <th>Order Item</th>
          <th>Customer</th>
          <th>In-charge</th>
          <th>Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in plans" :key="i">
          <td><span class="fw-bold">{{ displayValue(item.plan_number) }}</span></td>
          <td>{{ rowTitle(item) }}</td>
          <td>{{ displayValue(item.product_name) }}</td>
          <td>{{ displayValue(item.machine_name) }}</td>
          <td>
            <div class="schedule-cell">{{ formatDateTime(item.from_date_time) }}</div>
            <div class="schedule-cell text-muted">{{ formatDateTime(item.to_date_time) }}</div>
          </td>
          <td class="text-end">{{ item.qty }}</td>
          <td class="text-end">{{ item.produced_qty }}</td>
          <td class="text-end">
            {{ item.remaining_qty }}
            <span v-if="item.over_produced_qty > 0" class="badge bg-warning text-dark ms-1">
              +{{ item.over_produced_qty }}
            </span>
          </td>
          <td>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar" role="progressbar" :style="`width: ${progressPercent(item)}%`"></div>
            </div>
            <small class="text-muted">{{ progressPercent(item) }}%</small>
          </td>
          <td>{{ displayValue(item.order_number) }}</td>
          <td>{{ displayValue(item.line_item_product_name) }}</td>
          <td>{{ displayValue(item.customer_name) }}</td>
          <td>{{ displayValue(item.incharge_name) }}</td>
          <td>
            <span class="status-pill" :style="statusStyle(item.status)">{{ statusLabel(item.status) }}</span>
          </td>
          <td class="text-center">
            <button class="btn btn-primary btn-sm me-1" @click="$emit('onView', item)">
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!plans.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import { getProductionPlanStatusColor } from '@/services/utils/global'
import useDate from '@/services/utils/day'

defineProps({
  plans: {
    type: Array,
    default: () => []
  }
})

defineEmits(['onView'])

const { formatDate } = useDate()

function displayValue(value) {
  if (!value) return '-'
  return value
}

function rowTitle(item) {
  if (item.title) return item.title
  return displayValue(item.product_name)
}

function formatDateTime(value) {
  if (!value) return '-'
  const date = new Date(value.replace(' ', 'T'))
  if (isNaN(date.getTime())) return '-'
  return formatDate(date)
}

function progressPercent(item) {
  if (!item.qty) return 0
  const percent = (item.produced_qty / item.qty) * 100
  if (percent > 100) return 100
  return Math.round(percent)
}

function statusStyle(status) {
  const color = getProductionPlanStatusColor(status)
  return `background:${color.bg};color:${color.text};border:1px solid ${color.border}`
}

function statusLabel(status) {
  if (!status) return ''
  return status.replace('_', ' ')
}
</script>

<style scoped>
.plan-table {
  font-size: 0.8rem;
}

.plan-table thead th {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b7280;
  white-space: nowrap;
}

.schedule-cell {
  font-size: 0.72rem;
  white-space: nowrap;
}

.status-pill {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 12px;
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: capitalize;
  white-space: nowrap;
}
</style>
